import {LockIcon} from '@sanity/icons'
import {Text, Tooltip} from '@sanity/ui'

export function PrivateIcon() {
  return (
    <Tooltip
      content={
        <Text size={1} style={{whiteSpace: 'nowrap'}}>
          Only visible to you
        </Text>
      }
      fallbackPlacements={['bottom']}
      padding={2}
      placement="top"
      portal
    >
      <LockIcon />
    </Tooltip>
  )
}
